<template>
  <v-container
    fluid
    fill-height
    class="xs-only-px-0 pa-2"
  >
    <v-layout>
      <v-flex xs12>
        <v-card
          height="auto"
          style="min-height: 100%"
          class=""
        >
          <v-card-title class="headline">
            Account Admin
          </v-card-title>
          <div
            v-for="category in items"
            :key="category.title"
          >
            <v-card flat>
              <v-card-title class="subtitle-1  grey lighten-4">
                {{ category.title }}
              </v-card-title>
              <v-card-text>
                <v-btn
                  v-for="item in category.items"
                  :key="item.title"
                  :to="item.to"
                  text
                  color="primary"
                >
                  <font-awesome-icon
                    :icon="item.icon"
                    class="fa-lg fa-fw-20 mr-1"
                  />
                  {{ item.title }}
                </v-btn>
              </v-card-text>
            </v-card>
          </div>

          <v-card
            v-if="isAdmin"
            flat
          >
            <v-card-title class="subtitle-1  grey lighten-4">
              OL Admin
            </v-card-title>
            <v-card-text>
              <v-btn

                :to="'/oladmin/templates'"
                text
                color="primary"
              >
                <font-awesome-icon
                  :icon="['fal', 'cogs']"
                  class="fa-lg fa-fw-20 mr-1"
                />
                Templates
              </v-btn>
            </v-card-text>
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'Admin',
  data: () => ({
    items: [{
      title: 'User Management',
      icon: ['fal', 'address-book'],
      items: [
        {
          title: 'Clients',
          to: '/clients',
          icon: ['fal', 'address-book']
        },
        {
          title: 'Users',
          to: '/users',
          icon: ['fal', 'users']
        }
      ]
    }
    ]
  }),
  computed: {
    itemsSorted() {
      return this.items.slice(0).map(item => {
        return {
          ...item,
          items: item.items.slice(0).sort((a, b) => a.title.localCompare(b.title))
        }
      })
    }
  },
  beforeCreate() {
    this.mapGetters(['isAdmin'])
  }
}

</script>
